import cx from 'classnames';

import { SvgIcon } from '@/components';

import styles from './BlacklistBadge.module.sass';

interface BlacklistBadgeProps {
  flag: boolean;
  className?: string;
}

const BlacklistBadge = (props: BlacklistBadgeProps) => {
  const { flag, className } = props;

  if (!flag) {
    return null;
  }

  const icon = 'ban';

  const classes = cx(
    styles.badge,
    {
      [`${styles['badge--blacklist']}`]: flag,
    },
    className,
  );

  return (
    <div className={classes}>
      <div className={styles.inner}>
        <SvgIcon name={icon} className={styles.icon} />
      </div>
    </div>
  );
};

export default BlacklistBadge;
